module.exports = __webpack_public_path__ + "img/home-pre-order-additional-masks.6e1eadcf.png";